// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","condition-description-section":"ConditionDescriptionSection_condition-description-section__7s7vc"};